import {useLayoutEffect, useState} from 'react'

const useWindowSize = () => {
  const [size, setSize] = useState([0, 0])

  useLayoutEffect(() => {
    const updateSize = () => setSize([window.innerWidth, window.innerHeight])

    window.addEventListener('resize', updateSize)
    updateSize()

    return () => window.removeEventListener('resize', updateSize)
  }, [])

  const [innerWidth, innerHeight] = size
  return {innerWidth, innerHeight, isMobileDevice: innerWidth <= 768, isTabletDevice: innerWidth <= 1024}
}

export default useWindowSize
